var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hrproject-status",class:_vm.getProjectStatusClass},[_vm._v(" "+_vm._s(_vm.getProjectStatus)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }